import { createStore } from 'vuex'

import Loading from 'quasar/src/plugins/Loading.js';import QSpinnerBall from 'quasar/src/components/spinner/QSpinnerBall.js';

// var URL = 'http://localhost:5042/';
var URL = 'https://serversapakonsel.konaweselatankab.go.id/';

const store = createStore({
  state: {
    url : {
      URL_APP : URL,
      URL_BERANDA : URL + 'api/v1/server_beranda/',
      URL_LAPORAN : URL + 'api/v1/server_laporan/',
      URL_ARTIKEL : URL + 'api/v1/server_artikel/',
      URL_TENTANG  : URL + "api/v1/server_tentang/",
      URL_INFOGRAFIS : URL + 'api/v1/server_infografis/',
      URL_PENGGUNA : URL + 'api/v1/server_pengguna/',
      URL_JENIS : URL + 'api/v1/web_jenis/',
      URL_KATEGORI : URL + 'api/v1/web_publish_kategori/',
      URL_LEVEL : URL + "api/v1/web_publish_kelompok/",
    }
  },
  getters: {
  },
  mutations: {
    getStorage(state){
      var get_profile = JSON.parse(localStorage.profile);
      state.unit_kerja = get_profile.profile.unit_kerja; 
    },
    showLoading(){
      Loading.show({
        spinner : QSpinnerBall,
        spinnerColor: 'cyan-8',
        spinnerSize: 140,
        backgroundColor: 'grey-2',
        // message: 'Loading... Tunggu beberapa saat, system sedang menyesuaikan akun anda..!',
        // messageColor: 'white'
      })
    },
    hideLoading(){
      Loading.hide()
    },

  },
  actions: {
  },
  modules: {
  }
})

export default store;